// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "currency_before-GifGC";
var _3 = "currency_after-317QN";
export { _1 as "__esModule", _2 as "currency_before", _3 as "currency_after" }
export default { "__esModule": _1, "currency_before": _2, "currency_after": _3 }
